import * as React from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

const ConfirmDialog = (props) => {
  const { title, children, open, setOpen, onConfirm, onCancel } = props;

  return (
    <Dialog
      open={open}
      onClose={() => {
        setOpen(false);
        onCancel();
      }}
      maxWidth="xs"
      fullWidth
      aria-labelledby="confirm-dialog"
    >
      <DialogTitle id="confirm-dialog">
        {title}
        <IconButton
          aria-label="close"
          onClick={() => {
            setOpen(false);
            onCancel();
          }}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={() => {
            setOpen(false);
            onCancel();
          }}
          color="default"
          size="small"
        >
          No
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            setOpen(false);
            onConfirm();
          }}
          color="success"
          size="small"
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
